<template>
  <div>
    <section v-for="video in videos" class="card p-4 d-flex flex-direction-column justify-space-between">
        <div class="d-flex align-items-center">
          <router-link class="fs-5 break-word mr-2" :to="'/videos/' + video.id">
            {{ video.title }}
          </router-link>
          <!-- Only show SharedWithUsersIcon for the video owner -->
          <div class="d-flex" data-balloon="Shared" data-balloon-pos="up" v-if="video.is_shared && !video.shared" >
            <SharedWithUsersIcon />
          </div>
        </div>

      <div class="border">
        <p v-if="!video.processed && !video.transcode_error">Processing</p>
        <p v-else-if="video.transcode_error">Error!</p>

        <div v-if="!video.shared">
          <span class="bold text-muted">{{ video.user.name || video.user.email }}</span>
          <span v-if="video.uploader && video.uploader.id != video.user.id" class="bold text-muted">
            (Uploaded by: {{ video.uploader.name || video.uploader.email }})
          </span>
        </div>

        <div v-if="video.shared" class="d-flex align-items-center flex-wrap">
          <b class="mr-1">Shared by</b>
          <span class="d-flex align-items-center">
            <img
              class="user-profile-image m-0 mr-1"
              :src="video.user.avatar_url"
              />
            {{ video.user.name || video.user.email }}
          </span>

        </div>

        <time :datetime="video.created_on" class="text-muted bold">
          {{ video.created_on | formatTextDate }}
        </time>
      </div>

    </section>
  </div>
</template>

<script>
import store from '../store'

import Loader from './Loader.vue'
import SharedWithUsersIcon from './SharedWithUsersIcon.vue'
import { select } from '../directives.js'

import { formatTextDate } from '../filters.js'

export default {
  name: 'VideosTable',
  components: {
    Loader,
    SharedWithUsersIcon,
  },
  directives: {
    select,
  },
  filters: {
    formatTextDate,
  },
  props: {
    videos: {
      required: true,
    },
  },
  computed: {
    user () {
      return store.state.user
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '../_variables.scss';
// bulma override
.user-profile {
  cursor: pointer;
  user-select: none;

  &-image {
    $height: 26px;
    height: $height;
    width: $height;
    border-radius: 100%;
  }
}

.grid .border {
  @media (min-width: $mobile) {
    border-top: 1px solid lightgray;
    padding-top: 0.5rem;
    margin-top: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// VideosTable.vue?68588dde